import React from 'react';
import ReactDOM from 'react-dom';
//import Signup from './Signup';
import App from './App';
//import Signin from './Signin';








ReactDOM.render(<App />, document.getElementById('root'));

